import { render, staticRenderFns } from "./AnotherPlaces.vue?vue&type=template&id=426a4a5e&scoped=true&"
import script from "./AnotherPlaces.vue?vue&type=script&lang=js&"
export * from "./AnotherPlaces.vue?vue&type=script&lang=js&"
import style0 from "./AnotherPlaces.vue?vue&type=style&index=0&id=426a4a5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "426a4a5e",
  null
  
)

component.options.__file = "AnotherPlaces.vue"
export default component.exports